import { signout } from "../../../../../components/user/BCPAuth";
import { postNotification } from "../../../../../components/utilities/Notifications";
import { deleteData } from "../../../../../components/utilities/UtilityFunctions";
import { getEnvironmentVariable } from "../../../../../global/environmentVariables";
const SUPPORTS_BCP_PLATFORM_FEATURES =
  getEnvironmentVariable("SUPPORTS_BCP_PLATFORM_FEATURES") === "true";

export const deleteAccount = async (
  setIsProcessing,
  setIsModalOpen,
  password = "",
  signoutReducer,
  navigate,
  userId
) => {
  try {
    setIsProcessing(true);

    const deleteRequest = await deleteData(
      `/users/${userId}`,
      { body: { password } },
      "API"
    );

    if (deleteRequest && !deleteRequest?.error) {
      postNotification("success", "Account deletion process initiated", true);

      if (!SUPPORTS_BCP_PLATFORM_FEATURES) {
        await signout(signoutReducer, { navigate });
        setIsModalOpen(false);
      } else {
        setTimeout(() => {
          window.location.assign("/logout");
        }, 3000);
      }
    } else {
      throw new Error(
        deleteRequest?.error ||
          "Failed to delete account. Please try again later."
      );
    }
  } catch (error) {
    postNotification("error", error, true);
    setIsProcessing(false);
  }
};

export const boxSx = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: ["95vw", "85vw", 600],
  maxHeight: "95vh",
  bgcolor: "background.paper",
  border: "1px solid rgba(0, 0, 0, 0.12)",
  borderRadius: 1,
  boxShadow: 24,
  p: 4,
};
